export const clearPopupMessage =
  "The Clear Action will render the task undefined, and similarly, Associated dependent tasks will also be undefined.";
export const deletePopupMessage =
  "This action will Delete the task and all associated dependent tasks will be canceled.";
